
export const useUserClassroomsDataStore = () => {
  const userId = useCurrentUID();

  if (userId == undefined) throw new Error("User is not logged in");

  return useUserClassroomsData(userId)();
};
